import restClient from "../restClient";

export const getDealDetail = async (id, tab, tenantId) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        type: tab.toLowerCase().replace(/\s+/g, '-'),
        tenant: tenantId
      }
    };
    const response = await restClient.get(`deals/${id}`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const getDeals = async (search, status, page, pageSize, startDate, endDate, worksheetType, options = {}) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      signal: options.signal,
      params: {
        search,
        status,
        page,
        pageSize,
        ...(startDate ? { startDate } : {}),
        ...(endDate ? { endDate } : {}),
        ...(worksheetType?.length ? { worksheetType } : {}),
      }
    };
    const response = await restClient.get(`deals`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const deleteDeal = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.delete(`deals/${id}`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    return null;
  }
};

export const createDeal = async (data) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await restClient.post(`deals`, { data: data }, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};


export const updateDeal = async (id, data, tenantId) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        tenant: tenantId
      }
    };
    const response = await restClient.put(`deals/${id}`, { data: data }, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const sendDealSMS = async (dealId) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.post(`sms-service/deals/send`, {
      dealId,
      messageType: 'approval_request'
    }, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
